<template>
    <div class="selectWrap">
        <div class="selectContainer" @click="showPopup = !showPopup">
            <div class="flagCountry" v-html="currentItemData.logo">
                <!--<svg width="28" height="22" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                <!--<rect y="0.5" width="28" height="21" rx="4" fill="#FFDD2D"/>-->
                <!--<path d="M0 4.5C0 2.29086 1.79086 0.5 4 0.5H24C26.2091 0.5 28 2.29086 28 4.5V11H0V4.5Z" fill="#019BF2"/>-->
                <!--</svg>-->
            </div>
            <div class="selectIcon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.71017 11.71L11.3002 14.3C11.6902 14.69 12.3202 14.69 12.7102 14.3L15.3002 11.71C15.9302 11.08 15.4802 10 14.5902 10H9.41017C8.52017 10 8.08017 11.08 8.71017 11.71Z" fill="black" fill-opacity="0.54"/>
                </svg>
            </div>
        </div>
        <div v-if="showPopup" class="selectPopup" @click.stop="hidePopup">
            <div id="selectPopup_content" class="selectPopup_content">
                <div class="selectPopup_currentItem">
                    <li class="selectPopup_item" >
                        <div class="flag" v-html="currentItemData.logo"></div>
                        <p v-html="currentItemData.name"></p>
                        <span v-html="currentItemData.maskPlaceholder"></span>
                    </li>
                </div>
                <ul>
                    <li class="selectPopup_item" v-for="(item, index) in selectArray" @click.stop="setCurrentItem(index)">
                        <div class="flag" v-html="item.logo"></div>
                        <p v-html="item.name"></p>
                        <span v-html="item.maskPlaceholder"></span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "login-select-code",
        props: {
            selectArray: Array,
            defaultCurrentItem: {type: Number, default: 0},
        },
        data() {
            return {
                showPopup: false,
                el: null,
                currentItem: this.defaultCurrentItem,
            }
        },
        computed: {
            currentItemData: function () {
                if (this.selectArray && this.selectArray[this.currentItem])
                    return this.selectArray[this.currentItem];
                else
                    return {logo: '', name: '', maskPlaceholder: '',}
            },
        },
        methods: {
            setCurrentItem: function (index) {
                this.currentItem = index;
                this.showPopup = false;
                this.$emit('setItem', this.selectArray[this.currentItem])
            },
            hidePopup: function (e) {
                if (!this.el)
                    this.el = document.getElementById('selectPopup_content')
                if (this.el && !this.el.contains(e.target)) {
                    this.showPopup = false;
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    /*.rightContent .selectContainer {*/
        /*height: 54px;*/

    /*}*/
    .selectWrap {
        position: relative;
    }
    .selectContainer {
        height: 46px;
        min-width: 58px;
        display: flex;
        align-items: center;
        /*justify-content: space-around;*/
        justify-content: space-evenly;
        .flagCountry {
            text-align: left;
            height: 24px;
        }
        .selectIcon {
            text-align: right;
            cursor: pointer;
            height: 24px;
        }
    }
    .selectPopup {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,.6);
        z-index: 100;
        .selectPopup_content {
            /*margin: 0 16px;*/
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 328px;
            background: #fff;
            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
            border-radius: 8px;
            /*padding: 18px 0;*/
            padding-top: 16px;
            box-sizing: border-box;
            ul {
                margin: 0;
                padding: 8px 0;
                max-height: 50vh;
                overflow: auto;
            }
        }
        &_currentItem {
            padding: 0 0 12px;
            border-bottom: 1px solid  #BDD6E6;
            li {
                height: 28px;
                &:hover {
                    background-color: transparent;
                    cursor: default;
                }
            }
        }
        &_item {
            display: flex;
            justify-content: left;
            align-items: center;
            font-weight: 500;
            font-size: 16px;
            line-height: 19px;
            /*height: 32px;*/
            height: 44px;
            padding: 0 18px;
            &:hover {
                background-color: #E1F4F0;
            }
            p {
                margin-left: 16px;
            }
            span {
                margin-left: 8px;
                color: rgba(0, 0, 0, 0.38);
            }
            .flag {
                display: flex;
            }

        }
    }
    @media (min-width: 601px) and (max-width: 750px) {
        .selectPopup {
            background: none;

            .selectPopup_content {
                left: 75%;
            }
        }
        .selectContainer {
            height: 54px;
        }
    }
    @media (min-width: 751px) {
        .selectPopup {
            background: none;
            position: absolute;
            .selectPopup_content {
                top: 0;
                left: auto;
                transform: none;
                right: -15px;
                ul {
                    max-height: 150px;
                }
            }
        }
        .selectContainer {
            height: 54px;
        }
    }
</style>